import Vue from 'vue'
import Vuex from 'vuex'

import cinema from '@/api/cinema'

Vue.use(Vuex)

const store = new Vuex.Store({
    state:{
        movies:{},
    },
    mutations: {
        load: (state, movies) => {
            for(let key in movies) {
                let movie = movies[key]
                state.movies[movie['slug']] = movie
            }
        },
    },
    getters: {
        get: (state) => (slug) => {
            return state.movies[slug]
        },
        all: state => {
            return state.movies
        }
    },
    actions: {
        async getMovies (context) {
            if (Object.keys(context.state.movies).length === 0) {
                
                const response = await cinema.get('filmes.json')
                if (response.ok && response.data) {
                    context.commit('load', response.data.data)
                }
            }
        }
    }
})

export default store